<template>
    <section
        class="independent-content-wrapper"
        :class="getBemModifiers()"
    >
        <div class="independent-content-wrapper__container container">
            <h2
                v-if="title"
                class="independent-content-wrapper__title"
            >
                {{ title }}
            </h2>
            <h2
                v-if="subtitle"
                class="independent-content-wrapper__subtitle"
            >
                {{ subtitle }}
            </h2>
            <slot />
        </div>
    </section>
</template>

<script>
export default {
    name: 'IndependentContentWrapper',
    props: {
        title: {
            type: [String, Boolean],
            default: false,
        },
        subtitle: {
            type: [String, Boolean],
            default: false,
        },
    },
};
</script>

<style lang="scss">
    .independent-content-wrapper {
        $self: &;

        width: 100%;
        padding: 40px 0;
        background: $color-slate10;

        &__title {
            font: $font-weight-bold 24px/28px $goodHomeFontFamily;
            text-align: center;
            color: $color-slate100;
        }

        &__subtitle {
            margin: 8px 0 0 0;
            padding: 0;
            font: $font-weight-light 16px/22px $goodHomeFontFamily;
            text-align: center;
        }

        &--white {
            background: $color-castoWhite;
        }

        &--blue {
            background: $color-castoBlue;

            #{$self}__title {
                color: $color-castoWhite;
            }

            #{$self}__subtitle {
                color: $color-castoWhite;
            }
        }

        &--white-mobile {
            background: $color-castoWhite;
        }
    }

    @media (min-width: $mf-breakpoint-tablet) {
        .independent-content-wrapper--white-mobile {
            background: $color-slate10;
        }
    }

    @media (min-width: $mf-breakpoint-tablet) and (max-width: $mf-breakpoint-small-desktop) {
        .independent-content-wrapper__container.container {
            padding: 0;
        }
    }

    @media (min-width: $mf-breakpoint-small-desktop) {
        .independent-content-wrapper__title {
            font: $font-weight-bold 28px/30px $goodHomeFontFamily;
        }
    }

    @media (min-width: $mf-breakpoint-big-desktop) {
        .independent-content-wrapper__container.container {
            padding: 0 16px;
        }
    }
</style>
